export default "__VITE_ASSET__B2Eg0C$H__"